

import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  Typography,
  Modal,
  Backdrop,
  Fade,
  Grid,
  IconButton,
  CircularProgress,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  useMediaQuery,
  Tooltip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { toast, ToastContainer } from "react-toastify";
import SearchIcon from "@mui/icons-material/Search";
import InputAdornment from "@mui/material/InputAdornment";
import "react-toastify/dist/ReactToastify.css";
import { CreateBill, updateBillDetails, deleteBillDetails, getAllBillByOrgId, validatePassword } from "../services/api";
import { useUser } from "../context/UserContext";
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { useTheme } from "@mui/material/styles";
import SpinnerLoading from "../utility/LoadingIndicator";


const AddBillForm = () => {
  const { user } = useUser();

  const [formData, setFormData] = useState({
    billName: "",
    tcs: "",
    orgId: user.orgId,
  });
  const [errors, setErrors] = useState({});
  const [openModal, setOpenModal] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [billsList, setBillsList] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [open, setOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isLargeDevice = useMediaQuery(theme.breakpoints.up("lg")); // For large devices
  const isExtraLargeDevice = useMediaQuery(theme.breakpoints.up("xl"));
  const [loading, setLoading] = useState(true);
  const [password, setPassword] = useState("");
  const [passwordDialogOpen, setPasswordDailogOpen] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };





  const getAllBillsByUserOrgId = async (orgId) => {
    try {
      const response = await getAllBillByOrgId(orgId);
      if (response?.status === 200) {

        setBillsList(response.data.data);
        console.log("Bills", response.data);
      } else {
        setBillsList([]);
      }
    } catch (error) {
      console.error("Failed to fetch bills:", error);
      setBillsList([]);
    }
    finally {
      setLoading(false);

    }
  };

  const handleUpdateClick = (item) => {
    setSelectedItem(item);
    console.log(item);
    setIsModalOpen(true);
  };

  // Open confirmation dialog
  const handleDeleteClick = (item) => {
    setSelectedItem(item);
    setPasswordDailogOpen(true);
  };

  // Close dialog
  const handleClose = () => {
    setOpen(false);
    setSelectedItem(null);
  };

  // Confirm delete
  const handleConfirmDelete = () => {
    if (selectedItem) {
      deleteItem(selectedItem);
    }
    handleClose();
  };

  const deleteItem = async (bill) => {
    const billName = bill.billName;
    const tcs = bill.tcs;
    const id = bill._id;

    try {
      // Make the DELETE request
      const response = await deleteBillDetails(id);

      // Handle success response
      if (response.status === 200) {
        toast.success('Item and related records deleted successfully!');
        getAllBillsByUserOrgId(user.orgId);
        console.log('Response:', response.data);
        return response.data;
      }
    } catch (error) {
      // Handle error response
      console.error('Error deleting item:', error.response?.data || error.message);
      toast.error('Failed to delete the item. Please try again.');
      throw error;
    }

  };

  const handleCloseUpdateModal = () => {
    setIsModalOpen(false);
    setSelectedItem(null);
  };


  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: name === "billName" ? value.toUpperCase() : value, // Convert to uppercase if name is "billName"
    }));

    setErrors((prev) => ({
      ...prev,
      [name]: "", // Reset errors for the current field
    }));
  };


  const handleSaveChanges = async () => {
    console.log(selectedItem);

    // Call the update method with the modified item
    try {
      const response = await updateBillDetails(selectedItem._id, {
        billName: selectedItem.billName,
        tcs: selectedItem.tcs,
      });

      if (response.status === 200) {
        toast.success("Bill Details Successfully Updated..!");
        getAllBillsByUserOrgId(user.orgId);
        handleCloseUpdateModal();
      }
      if (
        response.message ===
        "Please change at least one value to update the item."
      ) {
        toast.warn("Please change at least one value to update the item.");
      }
    } catch (error) {
      if (error.response && error.response.status === 400) {
        const errorMessage = error.response.data.message;
        toast.error(errorMessage);
      } else {

        toast.error("An error occurred while updating the item.");
      }
    }

  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setSelectedItem((prev) => ({ ...prev, [name]: value }));
  };

  const validateForm = () => {
    let validationErrors = {};
    if (!formData.billName) validationErrors.billName = "Bill name is required.";
    ["tcs"].forEach((field) => {
      if (!formData[field] || isNaN(formData[field])) {
        validationErrors[field] = `${field.toUpperCase()} is required and must be a number.`;
      }
    });
    setErrors(validationErrors);
    return Object.keys(validationErrors).length === 0;
  };


  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) {
      setIsSubmitting(false); // Reset loading state if validation fails
      return;
    }

    setIsSubmitting(true); // Set loading state only after validation passes

    try {
      const response = await CreateBill(formData);

      if (response.status === 201) {
        toast.success("Bill created successfully!");
        setFormData({
          billName: "",
          tcs: "",
          orgId: user.orgId,
        });
        setOpenModal(false);
        getAllBillsByUserOrgId(user.orgId);
      } else if (response.status === 409) {
        // Handle conflict explicitly
        if (response.data && response.data.message) {
          toast.error(response.data.message); // Display the specific error message
        } else {
          toast.error("Failed to create the bill!");
        }
      }
    } catch (error) {
      // Handle other errors (network issues, unexpected API errors)
      if (error.response && error.response.data && error.response.data.message) {
        toast.error(error.response.data.message); // Display specific error message
      } else {
        toast.error("An unexpected error occurred. Please try again.");
      }
    } finally {
      setIsSubmitting(false); // Re-enable the button after processing
    }
  };




  const handleCloseModal = () => {
    setOpenModal(false);

    setErrors({});

  };


  const BillsList = Array.isArray(billsList)
    ? billsList.filter((item) =>
      Object.values(item).some((value) =>
        value.toString().toLowerCase().includes(searchTerm.toLowerCase())
      )
    )
    : [];

  const handleSearch = (event) => {
    setSearchTerm(event.target.value);
  };

  const handleRest = () => {
    setFormData({
      billName: "",
      tcs: "",
      orgId: user.orgId,
    });
  }

  useEffect(() => {
    getAllBillsByUserOrgId(user.orgId);
    setLoading(true);

  }, [user]);

  const handlePasswordVerify = async () => {
    try {
      console.log(user.userId);
      const response = await validatePassword(user.userId, password);
      if (response.status === 200) {

        setPasswordDailogOpen(false);
        setOpen(true);
        setPassword("");
      } else {
        toast.error("Password not verified. Please check password and try again.!");
      }
    } catch (error) {
      const errorMessage = error.response?.data?.message;

      if (errorMessage === "Invalid credentials.") {
        toast.error("Password not verified. Please check password and try again.");
      } else {
        toast.error(errorMessage || "User ID not found. Please enter correct UserID.");
      }
    }
  };

  return (
    <Box sx={{ textAlign: "center", pt: 1 }}>
      <ToastContainer />

      <Box sx={{ display: "flex", maxWidth: "100vw", justifyContent:"space-between", alignContent: "center", }}>
        
        <Box sx={{display:"flex",alignItems:'center',justifyContent:"center"}}>
        <Box sx={{}} >
          <Typography sx={{ textAlign: "initial", color: "#024CAA", fontSize: "30px" }}>
            Bills List
          </Typography>
        </Box>
        <Box>
          <TextField
            variant="outlined"
            fullWidth
            value={searchTerm}
            onChange={handleSearch}
            placeholder="Search by bill name"
            sx={{
              input: { color: "#071952", padding: "6px" },
              "& .MuiOutlinedInput-root": {
                "& fieldset": { borderColor: "#071952" },
                "&:hover fieldset": { borderColor: "#071952" },
                "&.Mui-focused fieldset": { borderColor: "#3572EF" },

              },
              marginLeft:"50px"



            }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <SearchIcon style={{ color: "#071952" }} />
                </InputAdornment>
              ),
            }}
          />
        </Box>
        
        </Box>
        <Box>
          <Button
            variant="contained"
            color="primary"
            onClick={() => {
              setOpenModal(true);
            }}
            sx={{ marginLeft: "20px", textTransform: "none" }}

          >
            Create Bill
          </Button>
        </Box>
        
      </Box>

      <TableContainer component={Paper}
        sx={{
          maxHeight: isExtraLargeDevice
            ? 480 // Height for extra-large devices
            : isLargeDevice
              ? 370 // Height for large devices
              : 300, // Default height for other devices
          maxWidth: isExtraLargeDevice ? "100vw" : "none", // Max-width cap for XL
          margin: isExtraLargeDevice ? "0 auto" : "inherit", // Center for XL
          overflowY: "auto",
          display: "flex",
          flexDirection: "column",
          textAlign: "center",
          "&::-webkit-scrollbar": {
            width: "6px",
            height: "6px",
          },
          "&::-webkit-scrollbar-track": { backgroundColor: "#f1f1f1" },
          "&::-webkit-scrollbar-thumb": {
            backgroundColor: "#888",
            borderRadius: "6px",
          },
          "&::-webkit-scrollbar-thumb:hover": { backgroundColor: "#555" },
        }}>
        <Table stickyHeader size={isMobile ? "small" : "medium"}>
          <TableHead sx={{ color: "#071952" }}>
            <TableRow>
              <TableCell sx={{
                textAlign: "center",
                color: "white",
                backgroundColor: "#133E87",
                fontWeight: "550",
                maxWidth: "250px",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}><strong>Bill Name</strong></TableCell>
              <TableCell sx={{
                textAlign: "center",
                color: "white",
                backgroundColor: "#133E87",
                fontWeight: "550",
                maxWidth: "250px",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}><strong>TCS</strong></TableCell>
              <TableCell sx={{
                textAlign: "center",
                color: "white",
                backgroundColor: "#133E87",
                fontWeight: "550",
                maxWidth: "250px",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}><strong>Actions</strong></TableCell>
            </TableRow>
          </TableHead>
          <TableBody >
            {BillsList.length > 0 ? (
              BillsList.reverse().map((bill) => (
                <TableRow key={bill._id} sx={{ textAlign: "center", padding: "0px" }}>
                  <TableCell sx={{ textAlign: "center", padding: "10px" }}>{bill.billName}</TableCell>
                  <TableCell sx={{ textAlign: "center", padding: "10px" }}>₹ {bill.tcs}</TableCell>
                  <TableCell align="center" sx={{ padding: "10px" }}>
                    <Tooltip title="Edit">
                      <IconButton onClick={() => handleUpdateClick(bill)}>
                        <EditIcon color="primary" />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Delete">
                      <IconButton onClick={() => handleDeleteClick(bill)}>
                        <DeleteIcon color="error" />
                      </IconButton>
                    </Tooltip>
                  </TableCell>
                </TableRow>
              ))
            ) : loading ? (<TableRow>
              <TableCell colSpan={7} align="center" sx={{ padding: 0, height: "60px" }}>
                <Box
                  display="flex"
                  justifyContent="center"
                  alignItems="center"
                  height="100%" // Spinner height inside table
                >
                  <SpinnerLoading color="primary" />
                </Box>
              </TableCell>
            </TableRow>) : (
              <TableRow>
                <TableCell colSpan={7} align="center" sx={{ color: "#133E87" }}>
                  No items found.
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Confirmation Dialog */}
      <Dialog open={open} onClose={handleClose} sx={{
        '& .MuiDialog-paper': {
          width: '400px', // Set the desired width
          maxWidth: '90%',
          paddingBottom: '20px',
          paddingRight: "20px", borderRadius: "8px"
        },
      }}>
        <DialogTitle sx={{ color: "#EB8317" }}>Confirm Delete</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to delete this bill? This action cannot be
            undone.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} variant="outlined" sx={{ textTransform: "none" }}>
            Cancel
          </Button>
          <Button
            onClick={handleConfirmDelete}
            color="primary"
            variant="contained"
            sx={{ textTransform: "none" }}

          >
            Confirm
          </Button>
        </DialogActions>
      </Dialog>

      {/* Verify Password Modal */}
      <Dialog
        open={passwordDialogOpen}
        onClose={() => setPasswordDailogOpen(false)}
        sx={{ borderRadius: "10px" }}
      >
        <DialogTitle style={{ color: "#006BFF" }}>Verify Password</DialogTitle>
        <DialogContent>
          <TextField
            sx={{ marginTop: "5px" }}
            label="Password"
            fullWidth
            size="small"
            type={showPassword ? "text" : "password"}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton onClick={togglePasswordVisibility} edge="end">
                    {showPassword ? <VisibilityOff /> : <Visibility />}
                  </IconButton>
                </InputAdornment>
              )
            }}
          />
        </DialogContent>
        <DialogActions sx={{ margin: "10px 14px 10px 0px " }}>
          <Button variant="outlined" onClick={() => setPasswordDailogOpen(false)} sx={{ textTransform: "none" }}>Cancel</Button>
          <Button variant="contained" onClick={handlePasswordVerify} color="primary" sx={{ textTransform: "none" }}>
            Verify
          </Button>
        </DialogActions>
      </Dialog>

      {/* Modal for Updating Item */}
      <Modal open={isModalOpen} onClose={handleCloseModal}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 400,
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            borderRadius: 2,
          }}
        >
          <IconButton
            onClick={handleCloseUpdateModal}
            sx={{ position: "absolute", top: 12, right: 8 }}
          >
            <CloseIcon />
          </IconButton>
          <h3 style={{ color: "#006BFF" }}>Update Bill</h3>
          {selectedItem && (
            <Box>
              <TextField
                fullWidth
                margin="normal"
                label="Bill Name"
                name="billName"
                value={selectedItem.billName}
                onChange={handleInputChange}
                size="small"

              />
              <TextField
                fullWidth
                margin="normal"
                label="TCS"
                name="tcs"
                value={selectedItem.tcs}
                onChange={handleInputChange}
                size="small"

              />

              <Box
                sx={{
                  display: "flex",
                  justifyContent: "flex-end",
                  marginTop: 2,
                  textTransform: "none",

                }}
              >

                <Button variant="outlined" onClick={handleCloseUpdateModal} sx={{ marginRight: "10px", textTransform: "none" }}>
                  Cancel
                </Button>
                <Button variant="contained" onClick={handleSaveChanges} sx={{ textTransform: "none" }}>
                  Update
                </Button>
              </Box>
            </Box>
          )}
        </Box>
      </Modal>

      <Modal
        open={openModal}
        onClose={handleCloseModal}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={openModal}>
          <Box
            sx={{
              maxWidth: 400,
              mx: "auto",
              mt: "10%",
              p: 5,
              bgcolor: "background.paper",
              borderRadius: 2,
              boxShadow: 3,
              position: "relative",
            }}
          >
            <Typography variant="h5" gutterBottom color="primary" marginBottom="16px">
              Create Bill
            </Typography>
            <IconButton
              onClick={handleCloseModal}
              sx={{ position: "absolute", top: 12, right: 8 }}
            >
              <CloseIcon />
            </IconButton>


            <>

              <form onSubmit={handleSubmit}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <TextField
                      label="Bill Name"
                      fullWidth
                      name="billName"
                      value={formData.billName}
                      onChange={handleChange}
                      error={!!errors.billName}
                      helperText={errors.billName}
                      size="small"
                    />
                  </Grid>
                  {["tcs"].map((field) => (
                    <Grid item xs={12} key={field}>
                      <TextField
                        label={field.toUpperCase()}
                        fullWidth
                        type="number"
                        name={field}
                        value={formData[field]}
                        onChange={handleChange}
                        error={!!errors[field]}
                        helperText={errors[field]}
                        size="small"
                      />
                    </Grid>
                  ))}
                </Grid>

                <Box sx={{ display: 'flex', justifyContent: "flex-end", alignItems: "center", textTransform: "none" }}>
                  <Box><Button sx={{ background: "#ED3EF7", borderRadius: "5px", marginTop: "15px", marginRight: "10px", textTransform: "none", color: "white" }} onClick={handleRest}>Reset</Button></Box>
                  <Box > <Button type="submit" sx={{ backgroundColor: "#006BFF", borderRadius: "5px", marginTop: "15px", textTransform: "none", color: "white" }} >{isSubmitting ? <CircularProgress size={24} color="inherit" /> : "Create Bill"}</Button></Box>
                </Box>
              </form>
            </>

          </Box>
        </Fade>
      </Modal>
    </Box>

  );
};

export default AddBillForm;
